import React from "react";
import { format, formatDistanceToNowStrict } from "date-fns";
import { Text, SimpleGrid, HStack } from "@chakra-ui/react";
import { CalendarLink, Card } from "components";
import { LineIcon } from "components/Icons";
import { Session } from "types";
import { isCancelledSession, isFutureSession } from "utils/session";
import StatusTag from "./StatusTag";

const SessionRow: React.FC<Session> = (session: Session) => {
  const { title, coach, start_time, end_time } = session;
  return (
    <Card>
      <SimpleGrid gap={4} columns={2} templateColumns="1fr fit-content(100%)">
        <Text fontSize="2xl" fontWeight="bold">
          {title}
        </Text>
        <HStack justifyContent="flex-end">
          {isFutureSession(session) && !isCancelledSession(session) && (
            <CalendarLink session={session} />
          )}
          <StatusTag status={session.status} />
        </HStack>
        <HStack spacing={2} fontWeight="light">
          <>
            <Text>
              {coach && `Coach ${coach.first_name} ${coach.last_name}`}
            </Text>
            <LineIcon color="blue.500" />
          </>
          <Text>{`${format(new Date(start_time), "p")} - ${format(
            new Date(end_time),
            "p"
          )}`}</Text>
        </HStack>
        <Text fontWeight="light" justifySelf="flex-end">
          {formatDistanceToNowStrict(new Date(start_time), { addSuffix: true })}
        </Text>
      </SimpleGrid>
    </Card>
  );
};

export default SessionRow;
